import React, { useCallback, useMemo } from "react";
import { makeVisualization, retrieveChartData } from "views/components/aggregationbuilder/AggregationBuilder";
import LineVisualizationConfig from "views/logic/aggregationbuilder/visualizations/LineVisualizationConfig";
import toPlotly from "views/logic/aggregationbuilder/visualizations/Interpolation";
import useChartData from "views/components/visualizations/useChartData";
import useEvents from "views/components/visualizations/useEvents";
import { DEFAULT_AXIS_TYPE } from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import useChartLayoutSettingsWithCustomUnits from "views/components/visualizations/hooks/useChartLayoutSettingsWithCustomUnits";
import useChartDataSettingsWithCustomUnits from "views/components/visualizations/hooks/useChartDataSettingsWithCustomUnits";
import usePlotOnClickPopover from "views/components/visualizations/hooks/usePlotOnClickPopover";
import XYPlot from "../XYPlot";
const LineVisualization = makeVisualization(
  ({ config, data, effectiveTimerange, height, width }) => {
    var _a;
    const visualizationConfig = (_a = config.visualizationConfig) != null ? _a : LineVisualizationConfig.empty();
    const getChartDataSettingsWithCustomUnits = useChartDataSettingsWithCustomUnits({ config });
    const { interpolation = "linear", axisType = DEFAULT_AXIS_TYPE } = visualizationConfig;
    const chartGenerator = useCallback(
      ({ type, name, labels, values, originalName, fullPath }) => ({
        type,
        name,
        x: labels,
        y: values,
        originalLabels: labels,
        originalName,
        line: { shape: toPlotly(interpolation) },
        ...getChartDataSettingsWithCustomUnits({ name, fullPath, values })
      }),
      [getChartDataSettingsWithCustomUnits, interpolation]
    );
    const rows = useMemo(() => retrieveChartData(data), [data]);
    const _chartDataResult = useChartData(rows, {
      widgetConfig: config,
      chartType: "scatter",
      generator: chartGenerator
    });
    const { eventChartData, shapes } = useEvents(config, data.events);
    const chartDataResult = useMemo(
      () => eventChartData ? [..._chartDataResult, eventChartData] : _chartDataResult,
      [_chartDataResult, eventChartData]
    );
    const getChartLayoutSettingsWithCustomUnits = useChartLayoutSettingsWithCustomUnits({
      config,
      chartData: chartDataResult
    });
    const layout = useMemo(() => {
      var _a2;
      const _layouts = getChartLayoutSettingsWithCustomUnits();
      if (shapes) {
        _layouts.shapes = [...(_a2 = _layouts.shapes) != null ? _a2 : [], ...shapes];
      }
      return _layouts;
    }, [shapes, getChartLayoutSettingsWithCustomUnits]);
    const { popover, initializeGraphDivRef, onChartClick } = usePlotOnClickPopover("scatter", config);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      XYPlot,
      {
        config,
        plotLayout: layout,
        axisType,
        effectiveTimerange,
        height,
        width,
        chartData: chartDataResult,
        onClickMarker: onChartClick,
        onInitialized: initializeGraphDivRef
      }
    ), popover);
  },
  "line"
);
export default LineVisualization;
